import React from 'react';
import { BoxArrowUpRight } from 'react-bootstrap-icons';

import useGroup from '../../hooks/use_group';
import useProduct from '../../hooks/use_product';
import useSiteMetadata from '../../hooks/use_site_metadata';
import useTranslation from '../../hooks/use_translation';
import { getGroupsByProduct } from '../../utils/helpers';
import LabLogos from '../labs/lab-logos';
import OfferNewCustomers from '../offers/offer_new_customers';
import Trustpilot from '../script/trustpilot';
import PaymentMethods from '../shop/payment-methods';
import Contact from './contact';
import GroupLink from './group_link';
import Link from './link';
import SectionHeader from './sections/section-header';

const Footer = () => {
	const siteMetadata = useSiteMetadata();
	const { items: groups } = useGroup({
		exclude_groups: [...siteMetadata.config.business_tests_groups],
	});
	const { items: products } = useProduct({
		exclude_groups: [...siteMetadata.config.business_tests_groups],
		has_markers: true,
		illegal_words: 'testosteron',
	});
	const { language, t } = useTranslation('component_footer');

	const groups_filtered = getGroupsByProduct({
		groups,
		language,
		products,
	});

	return (
		<footer className="footer mt-6" id="footer">
			<section className="section" id="footer-logos">
				<div className="container">
					<div className="">
						<SectionHeader
							excerpt={t('t9')}
							headingType="h3"
							size="sm"
							title={t('t7')}
							to="/partners/"
						/>
					</div>

					<LabLogos />
				</div>
			</section>

			<section className="py-lg-5 bg-gray-100">
				<div className="container my-lg-3 offer-new-customer">
					<OfferNewCustomers />
				</div>
			</section>

			<section className="section bg-primary">
				<div className="container my-lg-3">
					<h2 className="section-title text-center text-light">{t('t1')}</h2>
					<div className="trustpilot-wrapper trustpilot-wrapper-carousel my-4 my-lg-5">
						<Trustpilot theme="dark" type="carousel" />
					</div>
				</div>
			</section>
			<section className="section bg-dark">
				<div className="container">
					<div className="row justify-content-between align-items-center">
						<div className="col ">
							<SectionHeader
								headingType="h3"
								size="sm"
								title={t('t13')}
								to="/kontakt"
								variant="light"
							/>
						</div>
						<div className="col">
							<Contact variant="dark" />
						</div>
					</div>
				</div>
			</section>
			<div className="bg-dark">
				<div className="">
					<section className="container py-lg-6 py-5" id="footer-info">
						<div className="row">
							<div className="col-md-3 mt-0 mt-md-0">
								<p className="footer-title-sub">{t('t23')}</p>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/infor-provtagningen/"
								>
									{t('t23')}
								</Link>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/mottagningar/"
								>
									{t('t2')}
								</Link>
							</div>
							<div className="col-md-3 mt-4 mt-md-0">
								<p className="footer-title-sub">{t('t3')}</p>
								<Link
									className="x-small d-block text-decoration-none"
									to="/presentkort/"
								>
									{t('t34')}
								</Link>
								<Link
									className="x-small d-block text-decoration-none"
									to="/foretagshalsovard/"
								>
									{t('t5')}
								</Link>
								<Link
									className="x-small d-block text-decoration-none"
									target="_blank"
									to="https://zample.teamtailor.com/"
								>
									{t('t10')} <BoxArrowUpRight className="xs" />
								</Link>
								<Link
									className="x-small d-block text-decoration-none"
									to="/villkor/kopvillkor/"
								>
									{t('t18')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/priser/"
								>
									{t('t24')}
								</Link>
								{siteMetadata?.config?.campaigns && (
									<Link
										aria-current="page"
										className="x-small d-block text-decoration-none"
										to="/kampanjer/"
									>
										{t('t6')}
									</Link>
								)}
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/om-oss/"
								>
									{t('t29')}
								</Link>
							</div>
							<div className="col-md-3 mt-4 mt-md-0">
								<p className="footer-title-sub">{t('t25')}</p>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/blodprov/"
								>
									{t('t35')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/halsokontroll/"
								>
									{t('t8')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/halsoundersokningar/"
								>
									{t('t15')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/allergitester/"
								>
									{t('t41')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/nipt/"
								>
									{t('t40')}
								</Link>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/vardtjanster/"
								>
									{t('t16')}
								</Link>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/markorer/"
								>
									{t('t26')}
								</Link>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/allergener/"
								>
									{t('t27')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/artiklar/"
								>
									{t('t28')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/symtom/"
								>
									{t('t30')}
								</Link>
							</div>
							<div className="col-md-3 mt-4 mt-md-0">
								<p className="footer-title-sub">{t('t32')}</p>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/support/"
								>
									{t('t12')}
								</Link>

								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/kontakt/"
								>
									{t('t13')}
								</Link>
								<Link
									aria-current="page"
									className="x-small d-block text-decoration-none"
									to="/sa-fungerar-det/"
								>
									{t('t33')}
								</Link>
							</div>
						</div>
					</section>

					<section className="py-lg-6 py-5" id="footer-health">
						<div className="container">
							<SectionHeader
								aria-current="page"
								headingType="h3"
								size="sm"
								title={t('t4')}
								to="/tester/"
								variant="light"
							/>

							<div className="row">
								{Object.entries(groups_filtered.items).map(
									([group_id, group], index1) => {
										group_id = parseInt(group_id);
										return (
											<div className="col-md-3 col-6 mt-4" key={index1}>
												<p className="footer-title-sub text-break">
													{group.title}
												</p>

												{products.map((product, index2) => {
													if (!product.groups.includes(group_id)) return;

													return (
														<GroupLink
															aria-current="page"
															className="x-small d-block text-decoration-none"
															groups={
																product?.default?.group_id
																	? [product?.default?.group_id]
																	: product.groups
															}
															key={index2}
															page="tester"
															product_id={product.product_id}
														>
															{product.product_variant.title}
														</GroupLink>
													);
												})}
											</div>
										);
									},
								)}
							</div>
						</div>
					</section>

					<section className="py-lg-6 py-5 container" id="footer-footer">
						<div className="mb-5">
							<PaymentMethods variant="dark" />
						</div>
						<div className="row justify-content-between pt-4 align-items-center mb-3">
							<div className="col-md-6">
								<p className="xs text-gray-300 mb-0 d-block">{t('t14')}</p>
							</div>

							<div className="col-auto mt-4 mt-lg-0">
								<Link
									className="xs me-2 d-inline text-decoration-none"
									to="/klagomal/"
								>
									{t('t19')}
								</Link>
								<Link
									className="xs d-inline text-decoration-none"
									to="/villkor/"
								>
									{t('t11')}
								</Link>
							</div>
						</div>
					</section>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
